import React, { useState, useEffect, useContext } from "react";
import "./style.scss";
import DoctorContext from "../../ClinicComponents/ClinicWrapper/DoctorContext";
import DashboardAccounts from "../../common/DashboardAccounts/DashboardAccounts";

function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
}

const StaffDashboardRightContent = ({ scrollRef }) => {
  const staff_context = useContext(DoctorContext);
  const [doctor_selected, setDoctorSelected] = useState([]);
  const [key, setKey] = useState(0);

  useEffect(() => {
    if (staff_context.selectedDoctor.length > 0) {
      let arr = [];
      staff_context?.selectedDoctor &&
        staff_context.selectedDoctor.map((data) => arr.push(data.doctor_id));
      setDoctorSelected(arr);
      setKey((prev) => prev + 1);
    } else {
      setDoctorSelected([]);
    }
  }, [staff_context?.selectedDoctor]);

  return (
    <>
      <DashboardAccounts
        scrollRef={scrollRef}
        doctor_selected={doctor_selected}
        key={key}
      />
    </>
  );
};

export default StaffDashboardRightContent;
